export class ClinicLocation {
  public id: number;
  public address: string;
  public address_override: string;
  public city: string;
  public clinic: number;
  public country: string;
  public email: string;
  public name: string;
  public phone: string;
  public state: string;
  public zip: string;

  constructor(data: any = {}) {
    this.id = data.id || null;
    this.address = data.address || null;
    this.address_override = data.address_override || null;
    this.city = data.city || null;
    this.clinic = data.clinic || null;
    this.country = data.country || null;
    this.email = data.email || null;
    this.phone = data.phone || null;
    this.state = data.state || null;
    this.zip = data.zip || null;
    this.name = data.name || null;
  }

  public get descriptionAddress() {
    return this.city + (this.address ? `, ${this.address}` : '');
  }
}
